import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AlertSuppressionComponent } from './components/alert-suppression/alert-suppression.component';
import { AlertSuppressionPopupComponent } from './components/alert-suppression-popup/alert-suppression-popup.component';

const routes: Routes = [
  { path: '', component: AlertSuppressionPopupComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AlertSuppressionRoutingModule { }
